var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"list-customer-message-time",attrs:{"title":_vm.props.date_time}},[_vm._v(_vm._s(_vm.props.time_difference))])])}
var staticRenderFns = []

export { render, staticRenderFns }